/**
 * @generated SignedSource<<38a30387992960f02d7600ad4399fcf7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useSetUserIsMetricSystemMutation_user$data = {
  readonly rowId: any;
  readonly " $fragmentType": "useSetUserIsMetricSystemMutation_user";
};
export type useSetUserIsMetricSystemMutation_user$key = {
  readonly " $data"?: useSetUserIsMetricSystemMutation_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"useSetUserIsMetricSystemMutation_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useSetUserIsMetricSystemMutation_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "2711eb42f66754bd27aa6b8aa49099f7";

export default node;
